var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMusicSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.375 81.375H13.95C12.6659 81.375 11.625 80.3342 11.625 79.05V13.95C11.625 12.6659 12.6659 11.625 13.95 11.625H79.05C80.3342 11.625 81.375 12.6659 81.375 13.95V50.375",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 62L38.75 50.375L60.0625 60.0625",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38.75C57.7197 38.75 54.25 35.2802 54.25 31C54.25 26.7198 57.7197 23.25 62 23.25C66.2803 23.25 69.75 26.7198 69.75 31C69.75 35.2802 66.2803 38.75 62 38.75Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.625 73.625V85.25M62 73.625H73.625H62ZM85.25 73.625H73.625H85.25ZM73.625 73.625V62V73.625Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMusicSheet);
export default __webpack_public_path__ + "static/media/addMusicSheet.c0dc9c512ade5b2de7139f5a78d1bf14.svg";
export { ForwardRef as ReactComponent };